import { RegisterEventBus } from '@/buses/register-bus.js';
import { AccommodationType, FieldCodes } from '@/models/enums';
import moment from 'moment';
import store from '@/store/store';

class DynamicFieldChangeHandler {
    getFieldCode(model) {
        return model.fieldCode;
    };

    eventStartDateChangeHandler(newValue, oldValue, model, register) {
        if (!store.getters.appSettings.recalcSubscriptionDates) return;

        if (!model || !register || !register.panels) return;

        for (var i = 0; i < register.panels.length; i++) {
            const panel = register.panels[i];
            if (!panel.components) continue;

            for (var j = 0; j < panel.components.length; j++) {
                let component = panel.components[j];

                if (component.fieldCode === FieldCodes.EventSubscriptionStartDate) {
                    if (model.fieldValue.datetimeValue) {
                        // From Kendo DatePicker comes GMT date
                        let dateUtc = moment.utc(model.fieldValue.datetimeValue);
                        const utcStr = dateUtc.add(-30, 'days').toISOString();
                        if (utcStr) {
                            // Z index has to be removed
                            component.fieldValue.datetimeValue = utcStr.replace('Z', '');
                        }

                        if (RegisterEventBus) {
                            RegisterEventBus.$emit(`component-${component.fieldCode}-${component.id}-reset`)
                        }
                    }
                    break;
                }
            }
        }
    }

    eventEndDateChangeHandler(newValue, oldValue, model, register) {
        if (!store.getters.appSettings.recalcSubscriptionDates) return;

        if (!model || !register || !register.panels) return;

        for (var i = 0; i < register.panels.length; i++) {
            const panel = register.panels[i];
            if (!panel.components) continue;

            for (var j = 0; j < panel.components.length; j++) {
                let component = panel.components[j];

                if (component.fieldCode === FieldCodes.EventSubscriptionEndDate) {
                    if (model.fieldValue.datetimeValue) {
                        // From Kendo DatePicker comes GMT date
                        let dateUtc = moment.utc(model.fieldValue.datetimeValue);
                        const utcStr = dateUtc.add(-20, 'days').toISOString();
                        if (utcStr) {
                            // Z index has to be removed
                            component.fieldValue.datetimeValue = utcStr.replace('Z', '');
                        }

                        if (RegisterEventBus) {
                            RegisterEventBus.$emit(`component-${component.fieldCode}-${component.id}-reset`)
                        }
                    }
                    break;
                }
            }
        }
    }

	eventAccommodationTypeChangeHandler(newValue, oldValue, model, register) {
		if (newValue === AccommodationType.WithourAccommodation) {
			const panel = register.panels.filter(p => p.components.filter(c => c.fieldCode === FieldCodes.AccommodationType).length > 0)[0];
			if (panel && panel.components && panel.components.length > 0) {
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.LastDayForBooking, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventAccommodationPlaceName, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.AccommodationAddress, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventStayFrom, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventStayTo, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventDailyAllowanceFrom, true);
				this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventDailyAllowanceTo, true);
			}
		} else if (oldValue === AccommodationType.WithourAccommodation) {
			const panel = register.panels.filter(p => p.components.filter(c => c.fieldCode === FieldCodes.AccommodationType).length > 0)[0];
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.LastDayForBooking, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventAccommodationPlaceName, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.AccommodationAddress, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventStayFrom, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventStayTo, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventDailyAllowanceFrom, false);
			this.setComponentWithCodeToReadonly(panel.components, FieldCodes.EventDailyAllowanceTo, false);
		}
	}

	setComponentWithCodeToReadonly(components, code, isReadonly) {
        let component = components.filter(c => c.fieldCode === code)[0];
        if (component) {
            component.isReadOnly = isReadonly;
		}
	}

    onChangeHandler(newValue, oldValue, model, register) {
        const fieldCode = this.getFieldCode(model);
        if (!fieldCode) return;

        switch (fieldCode) {
            case FieldCodes.EventStartDate:
                this.eventStartDateChangeHandler(newValue, oldValue, model, register);
                break;
            case FieldCodes.EventEndDate:
                this.eventEndDateChangeHandler(newValue, oldValue, model, register)
                break;
			case FieldCodes.AccommodationType:
				this.eventAccommodationTypeChangeHandler(newValue, oldValue, model, register)
				break;
            default:
                break;
        }
    }
}

export default new DynamicFieldChangeHandler();
